import { SHOW_ORDER_PRICES, termLabel } from "./orderPricing";
// interface PricingPlan {
//   plan_id: string;
//   name: string;
//   price: number;
//   currency: string;
//   period: number;
//   period_unit: string;
//   external_name: string;
//   nrc?: {
//     plan_id: string;
//     name: string;
//     price: number;
//     currency: string;
//     external_name: string;
//   };
// }

// type PricingPlans = {
//   [portType: string]: {
//     [capacity: string]: {
//       [termKey: string]: PricingPlan;
//     };
//   };
// };

// export const calculatePricingOptions = (
//   pricingPlans: PricingPlans | null,
//   selectedPortType: string,
//   selectedCapacity: string
// ) => {
//   if (
//     !pricingPlans ||
//     !pricingPlans[selectedPortType] ||
//     !pricingPlans[selectedPortType][selectedCapacity]
//   ) {
//     return [];
//   }

//   const plansForCapacity = pricingPlans[selectedPortType][selectedCapacity];

//   return Object.keys(plansForCapacity).map((termKey) => {
//     const plan = plansForCapacity[termKey];
//     const effectivePrice = plan.nrc ? plan.nrc.price : plan.price;
//     return {
//       // Use the plan.period (in months) as the value
//       value: plan.period.toString(), 
//       label: `${plan.period} Months - $${effectivePrice} / ${plan.period_unit}`,
//       price: effectivePrice,
//       currency: plan.currency,
//       term: plan.period,
//       nrcApplied: !!plan.nrc,
//     };
//   });
// }
  

interface PricingPlan {
  plan_id: string;
  name: string;
  price: number;
  currency: string;
  period: number;
  period_unit: string;
  external_name: string;
  nrc?: {
    plan_id: string;
    name: string;
    price: number;
    currency: string;
    external_name: string;
  };
}

type PricingPlans = {
  [portType: string]: {
    [capacity: string]: {
      [termKey: string]: PricingPlan;
    };
  };
};
interface PricingOption {
  value: string;
  label: string;
  term: number;
  price: number;
  currency: string;
  nrcApplied: boolean;
}

export const calculatePricingOptions = (
  pricingPlans: PricingPlans | null,
  selectedPortType: string,
  selectedCapacity: string
): PricingOption[] => {
  // Define the base contract options.
  const baseOptions: PricingOption[] = [
    {
      value: "12",
      label: termLabel(12),
      term: 12,
      price: 0,
      currency: "USD",
      nrcApplied: false,
    },
    {
      value: "24",
      label: termLabel(24),
      term: 24,
      price: 0,
      currency: "USD",
      nrcApplied: false,
    },
    {
      value: "36",
      label: termLabel(36),
      term: 36,
      price: 0,
      currency: "USD",
      nrcApplied: false,
    },
  ];


  // If pricing data is not available for this selection, return the base options.
  if (
    !SHOW_ORDER_PRICES ||
    !pricingPlans ||
    !pricingPlans[selectedPortType] ||
    !pricingPlans[selectedPortType][selectedCapacity]
  ) {
    return baseOptions;
  }

  const plansForCapacity = pricingPlans[selectedPortType][selectedCapacity];

  // Merge base options with dynamic pricing.
  const mergedOptions = baseOptions.map((baseOption) => {
    // Find a plan with a matching period.
    const plan = Object.values(plansForCapacity).find(
      (p) => p.period === baseOption.term
    );
    if (plan) {
      const effectivePrice = plan.nrc ? plan.nrc.price : plan.price;
      return {
        value: baseOption.value,
        label: `${baseOption.term} Months - $${effectivePrice} / ${plan.period_unit}`,
        price: effectivePrice,
        currency: plan.currency,
        term: plan.period,
        nrcApplied: !!plan.nrc,
      };
    }
    return baseOption;
  });

  return mergedOptions;
};
